// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Button, Toastr, Label } from "@revvsales/components";

// Components Imports

// Action Imports
import { AssetActions } from "../../../../actions";

// Internal Imports
import { ASSET, EVENTS } from "../../../../constants";
import { AmplitudeUtils } from "../../../../utils";

// Destructuring
const { renameAssetItemAction } = AssetActions;
const { ASSET_ITEM_TYPES } = ASSET;
const { amplitudeLogEvent } = AmplitudeUtils;

const ENTER_KEY = 13;

class AssetItemRenamePopup extends Component {
  state = { folderName: "", showButtunLoader: false, errMsg: "" };

  componentDidMount() {
    const { selectedItem } = this.props;
    if (selectedItem && selectedItem.items && selectedItem.items.length > 0) {
      this.setState({ folderName: selectedItem.items[0].folderName });
    }
    if (this.folderNameInput) {
      this.folderNameInput.focus();
    }
  }

  _onInputChange = e => {
    if (e.target.value && e.target.value.includes("/")) {
      this.setState({
        errMsg: "Forward slash '/' is not allowed in folder name",
      });
    } else {
      this.setState({ folderName: e.target.value, errMsg: "" });
    }
  };

  _closePopup = () => {
    this.props.closePopup("showAssetItemRenamePopup", false);
  };

  _renameItemHandler = () => {
    this.setState({ showButtunLoader: true, errMsg: "" });
    const { selectedItem } = this.props;
    const payload = {};
    if (selectedItem && selectedItem.items && selectedItem.items.length > 0) {
      payload.id = selectedItem.items[0].folderId;
      payload.data = {
        name: this.state.folderName,
      };
    }
    this.props
      .renameAssetItem(payload, this.props.selectedItem)
      .then(response => {
        const { name } = response.item;
        this.setState({ showButtunLoader: false, errMsg: "" });
        if (this.props.selectedItem.items[0].folderType === "d") {
          amplitudeLogEvent(EVENTS.EVENT_NAMES.FOLDER_RENAMED, {
            initiatedFrom: "Asset",
            folderId: this.props.selectedItem.items[0].folderId,
          });
        } else {
          amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_RENAMED, {
            initiatedFrom: "Asset",
          });
        }

        Toastr.showToastr({
          type: "success",
          message: `${name} renamed successfully.`,
          timeout: 3000,
        });
        this._closePopup();
      })
      .catch(error => {
        const err = error.response;
        console.error(
          `AssetItemRenamePopup => _renameItemHandler => Error : ${error}`,
        );
        this.setState({
          showButtunLoader: false,
          errMsg:
            err && err.data && err.data.message
              ? err.data.message
              : "Something went wrong!..",
        });
      });
  };

  _handleKeyDown = e => {
    if (e.keyCode === ENTER_KEY && this.state.folderName !== "") {
      this._renameItemHandler();
    }
  };

  render() {
    const { folderName, showButtunLoader, errMsg } = this.state;
    const {
      selectedItem: { items },
    } = this.props;
    const disabled = !folderName;
    const errMsgSpace = errMsg ? (
      <div className="modal-error-message">{errMsg}</div>
    ) : null;
    let itemType = "Folder";
    if (
      items &&
      items.length > 0 &&
      (items[0].folderType === ASSET_ITEM_TYPES.DOCUMENT ||
        items[0].type === ASSET_ITEM_TYPES.DOCUMENT ||
        items[0].folderType === ASSET_ITEM_TYPES.DOCUMENT_FORM ||
        items[0].type === ASSET_ITEM_TYPES.DOCUMENT_FORM)
    ) {
      itemType = "File";
    }
    let prevItemName = null;
    const { selectedItem } = this.props;
    if (selectedItem && selectedItem.items && selectedItem.items.length > 0) {
      prevItemName = selectedItem.items[0].folderName;
    }
    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        <div
          className="modal-container assetitemrenamepopup-container"
          data-test="assetitemrenamepopup-container">
          <div
            className="modal-heading"
            data-test="assetitemrenamepopup-modal-heading">
            Rename {prevItemName || "selected item"}
          </div>
          {errMsgSpace}
          <div className="modal-form">
            <div
              className="modal-form-field"
              data-test="assetitemrenamepopup-form">
              <Label
                htmlFor="userEmail"
                data-test="assetitemrenamepopup-form-label">
                {itemType} Name
              </Label>
              <input
                className="form-control"
                data-test="assetitemrenamepopup-form-inputfield"
                type="text"
                name="folderName"
                value={folderName}
                onChange={this._onInputChange}
                onKeyDown={this._handleKeyDown}
                placeholder="Enter a folder name."
                ref={name => {
                  this.folderNameInput = name;
                }}
              />
            </div>
          </div>

          <div className="modal-footer">
            <Button
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="assetitemrenamepopup-cancle-btn"
              onClick={this._closePopup}>
              Cancel
            </Button>
            <Button
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="assetitemrenamepopup-submit-btn"
              disabled={disabled}
              onClick={this._renameItemHandler}
              isLoading={showButtunLoader}>
              Rename
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  renameAssetItem: renameAssetItemAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(AssetItemRenamePopup);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetDetails/AssetItemRenamePopup/index.js